module.exports = __webpack_public_path__ + "static/img/companyBg.2b31058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/companyBg.png
// module id = +I2p
// module chunks = 1